import React, {useContext, useEffect, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import DropDown2 from "../../Generic/dropDown2";
import {getAvailableWizardVisualizerOptions} from "../../WizardSetup/WizardSetupTopVisualizerSelect";
import {getWizardList} from "../../WizardSetup/wizardActions";
import {getWizardGroupsOptions, getWizardOption, getWizardsOptions} from "./DiscountsPopupDropdownsOptions";
import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import WizardGroupsFlow from "../../WizardSetup/WizardGroups/WizardGroupsFlow";
import {UI_POPUP_TYPES} from "../../../reducers/R_Popups";
import {setUiPopupState} from "../../../actions/A_Popups";
import {setWorkSheetWizardSelections} from "../discountsActions";
import {WIZARD_GROUP_TYPES} from "../../WizardSetup/WizardItem/wizardItemInterface";


const DiscountsPopupContentWizardButton = (props) => {

  const {uiPopupState, setUiPopupState, setWorkSheetWizardSelections} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {forWizardGroupId, forWizardGroupTitle, forWizardGroupName} = uiPopupContext;

  const onWizardGroupSelect = (wizardGroup) => {
    setWorkSheetWizardSelections(false);
    const newTitle = wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom
      ? wizardGroup.productCartTitle || wizardGroup.title
      : wizardGroup.customDisplayName || wizardGroup.title;
    setUiPopupState({
      ...uiPopupState,
      style: {maxWidth: "480px", maxHeight: "320px"},
    });
    uiPopupDispatch({
      "forWizardGroupTitle": newTitle,
      "forWizardGroupId": wizardGroup.id,
      "forWizardGroupName": wizardGroup.groupName,
      "saveButtonDisabled": false
    })
  }

  const editWizardGroupClick = () => {
    setWorkSheetWizardSelections(true, forWizardGroupId, onWizardGroupSelect);
    setUiPopupState({
      ...uiPopupState,
      style: {maxWidth: "100%", maxHeight: "100%"},
    });
  }

  return (
    <div className="flex flex--center flex--start">
      {forWizardGroupTitle || forWizardGroupName ? (
        <span className="bold font--15 margin-r8 pr-two-lines text-left">
          {forWizardGroupTitle || forWizardGroupName}
        </span>
      ) : null}
      <button className="ui-icon-edit ui-icon-edit--small relative" onClick={editWizardGroupClick}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {uiPopupState} = store.popups;
  return {
    uiPopupState
  };
};

const mapDispatchToProps = {
  setUiPopupState,
  setWorkSheetWizardSelections,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DiscountsPopupContentWizardButton)
)
